import { css } from "@emotion/react";
import { theme } from "@xometry/xometry_loft";

const loginModal = css`
  position: fixed;
  top: 4%;
  left: 50%;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  -webkit-transform: translateX(-50%);
  max-width: 92%;
  width: 404px;
  padding: ${theme.space[3]} 6px;
  border: 0px solid rgb(204, 204, 204);
  background: rgb(255, 255, 255) none repeat scroll 0% 0%;
  background-color: ${theme.colors.white};
  text-align: center;
  line-height: 400%;
  color: ${theme.colors.darkBlues[100]};
  box-shadow: 0 1px 4px 0 rgba(37, 56, 66, 0.2);

  ${theme.mediaQueries.small} {
    top: 15%;
  }
  ${theme.mediaQueries.medium} {
    top: 25%;
  }
`;

const loginButton = css`
  width: 100%;
  align-self: center;
  margin: ${theme.space[3]} auto;
`;

const title = css`
  font-size: 26px;
  padding: 0;

  ${theme.mediaQueries.small} {
    font-size: 28px;
    padding: 10px;
  }
`;

const content = css`
  line-height: 150%;
  padding: ${theme.space[3]};
  font-size: ${theme.fontSizes[0]};
  align-self: center;
  width: 85%;

  ${theme.mediaQueries.small} {
    width: 75%;
  }

  label {
    text-align: left;
    margin-top: ${theme.space[4]};
  }
  label > span {
    font-weight: ${theme.fontWeights.regular};
  }
  input {
    width: 100%;
  }
`;

const passwordWrapper = css`
  div {
    width: 100%;
  }
`;

const links = css`
  margin-bottom: ${theme.space[4]};
  line-height: ${theme.space[6]};
  font-size: ${theme.fontSizes[0]};
`;

const checkboxWrapper = css`
  display: flex;
  align-items: center;

  label {
    padding-left: 0;
    margin-bottom: 0;
    cursor: pointer;
  }
`;

const flowButton = css`
  padding: 8px 12px;
`;

export {
  loginModal,
  title,
  loginButton,
  content,
  passwordWrapper,
  links,
  checkboxWrapper,
  flowButton,
};
